const cartDrawer = () => ({
  init() {
    // set up listeners for Swym wishlist
    window.SwymCallbacks.push((swat) => {
      swat.evtLayer.addEventListener('sw:addedtocart', (e) => {
        this.updateAndOpenCart(e);
      });
    });

    this.loadTemplate();

    window.__vslyUpdateCart = () => {
      try {
        this.$store.cart.fetchCart();
      } catch (ex) {
        console.error('Error refreshing cart', ex);
      }
    };
  },

  loadTemplate() {
    const content = document
      .querySelector('.js-cart-template')
      .content.cloneNode(true);
    content.querySelector('.cart').classList.add('cart--drawer');
    this.$root.replaceChildren(content);
  },

  openCart() {
    this.$root.closest('dialog').showModal();
  },

  closeCart() {
    this.closeOpenDrawers();
  },

  async updateAndOpenCart({ detail }) {
    await this.$store.cart.fetchCart();

    if (detail?.noOpenAfterUpdate) {
      return;
    }

    this.$root.closest('dialog').showModal();
  },
});

export default cartDrawer;
